import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn from './locales/en/translation.json';

export const defaultNS = 'translations';
export const resources = {
  en: {
    translations: translationEn,
  },
};
i18n.use(initReactI18next).init({
  supportedLngs: ['en'],
  fallbackLng: 'en',
  ns: ['translations'],
  defaultNS,
  resources,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['path', 'cookie', 'htmlTag'],
    caches: ['cookie'],
  },
  keySeparator: false,
  react: { useSuspense: true },
});

export default i18n;
